import { icons } from 'assets';
import Button from 'Components/shared/button';
import Modal from 'Components/shared/modal';
import Text from 'Components/shared/text';
import React from 'react';

import styles from '../wallet.module.css';

const TransactionEnd = ({onClose, success=true,openModal, onSuccess, onError, message, ...props}) => {
   
    return (
        <Modal open={openModal} onClose={onClose} disableBackdropClick variant='dark' >
            {
                success? (
                    <div>
                        <div style={{width:"70%", margin:"auto", textAlign:"center"}}>
                            <img src={icons.mark} alt="" style={{textAlign:"center",marginBottom:"10px", width:"70px"}}/>
                            <Text variant="md2" style={{fontWeight:800, paddingBottom:"8px"}}>
                                Successful
                            </Text>
                            <Text color="secondary">Your request was successful</Text>
                            
                        </div>
                        
                        <div className="row-start" style={{width:"60%",margin:"34px auto"}}>
                            
                            <Button onClick={onSuccess}> Close</Button>
                        </div>
                    </div>
                ):(<div>
                        <div style={{ textAlign: "center" }}>
        <div>
          <img src={icons.error} style={{ width: "90px", height: "90px" }} />
        </div>
        <Text variant="lg" style={{ fontWeight: "600" }}>
          Error Occured
        </Text>
        <Text
          variant="xs"
          style={{ color: "var(--social-color)", paddingTop: "1rem" }}
        >
          {message}
        </Text>
      </div>

      <div
        className="row-start"
        style={{
          justifyContent: "center",
          marginTop: "2rem",
        }}
      >
        <div className="row-start w-full" >
          <Button
            label="Close"
            className={(styles.button, styles.cancel)}
            onClick={onError}
          />
        </div>
      </div>
                    </div>)
            }
            
        </Modal>
    )
}



export default TransactionEnd;